import { useEffect, useState } from 'react'

export default function useDebounce<T>(value: T, delay: number) {
	let [debouncedValue, setDebouncedValue] = useState(value)

	useEffect(() => {
		let handler = setTimeout(() => {
			setDebouncedValue(value)
		}, delay)

		return () => {
			clearTimeout(handler)
		}
	}, [value, delay])

	return debouncedValue
}
